"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEHAVIOR_EVENT = exports.EXPOSE_FEGO_METHOD = exports.ShareEventMarket = exports.CHANNEL_MAP = exports.SHARE_SHOW_TYPE = exports.SHARE_TYPE = exports.getShareChannels = exports.WECHAT = exports.SHARE_CHANNELS = void 0;
// app分享渠道
exports.SHARE_CHANNELS = {
    // 系统分享
    SYSTEM: 'system',
    // reddit
    REDDIT: 'reddit',
    // fb
    FACEBOOK: 'facebook',
    // telegram
    TELEGRAM: 'telegram',
    // 小红书
    XIAOHONGSHU: 'xiaohongshu',
    // tw
    TWITTER: 'twitter',
    // ins
    INSTAGRAM: 'instagram',
    // whatsapp
    WHATSAPP: 'whatsapp',
    // wxFriend: 微信好友
    WXFRIEND: 'wxFriend',
    // wxTimeline: 微信朋友圈
    WXTIMELINE: 'wxTimeline',
    // 复制链接: 选择了分享链接时才有这个渠道
    COPY: 'copy'
};
exports.WECHAT = 'wechat';
const getShareChannels = () => {
    return [...Object.values(exports.SHARE_CHANNELS)];
};
exports.getShareChannels = getShareChannels;
// 分享类型
exports.SHARE_TYPE = {
    // 图片分享
    IMAGE: 1,
    // 链接分享
    LINK: 0
};
exports.SHARE_SHOW_TYPE = {
    // 1: 多图单选  2: 多图多选  3: 单图单选（快照分享）  4: 结构化数据
    // 5: 快速分享 快速分享可以理解为只支持一个渠道的分享，因此需要快速分享只需把showType设为5，enable_channel字段指定具体的**一个**渠道
    // 6: 同时分享图片和结构化数据,默认展示结构化数据 7: 同时分享图片和结构化数据,默认展示图片
    QuickShare: 5,
    bothButPicFirst: 7
};
// channel分享上报映射值
exports.CHANNEL_MAP = {
    niuyou: '4', // 聊天
    nnq: '5', // 牛牛圈、moomoo圈
    wxFriend: '0', // 微信好友
    wxTimeline: '1', // 微信朋友圈
    qq: '2', // QQ
    weibo: '3', // 新浪微博
    facebook: '7', // fb
    twitter: '8', // tw
    whatsapp: '9', // whatsapp
    sms: '13', // 短信分享
    email: '14', // 邮件分享
    copy: '15', // 复制
    messenger: '11', // messenger
    instagram: '12', // ins
    dingtalk: '16', // 钉钉
    line: '17', // line
    telegram: '18', // telegram
    xiaohongshu: '19', // 小红书
    reddit: '20' // reddit
};
// 市场，编辑器选择，与事件上报相关
exports.ShareEventMarket = {
    HK: '1',
    SG: '2',
    MY: '3',
    US: '4',
    JP: '5',
    CA: '6',
    AU: '7'
};
// 暴露到fego的方法
exports.EXPOSE_FEGO_METHOD = [
    {
        methodName: 'shareToMore',
        methodLabel: '使用系统分享',
        label: '系统分享',
        value: exports.SHARE_CHANNELS.SYSTEM
    },
    {
        methodName: 'shareToReddit',
        methodLabel: '分享到Reddit',
        label: 'Reddit',
        value: exports.SHARE_CHANNELS.REDDIT
    },
    {
        methodName: 'shareToFacebook',
        methodLabel: '分享到Facebook',
        label: 'Facebook',
        value: exports.SHARE_CHANNELS.FACEBOOK
    },
    {
        methodName: 'shareToTelegram',
        methodLabel: '分享到Telegram',
        label: 'Telegram',
        value: exports.SHARE_CHANNELS.TELEGRAM
    },
    {
        methodName: 'shareToXiaohongshu',
        methodLabel: '分享到小红书',
        label: '小红书',
        value: exports.SHARE_CHANNELS.XIAOHONGSHU
    },
    {
        methodName: 'shareToX',
        methodLabel: '分享到X',
        label: 'X',
        value: exports.SHARE_CHANNELS.TWITTER
    },
    {
        methodName: 'shareToInstagram',
        methodLabel: '分享到Instagram',
        label: 'Instagram',
        value: exports.SHARE_CHANNELS.INSTAGRAM
    },
    {
        methodName: 'shareToWhatsapp',
        methodLabel: '分享到Whatsapp',
        label: 'Whatsapp',
        value: exports.SHARE_CHANNELS.WHATSAPP
    },
    {
        methodName: 'shareToWxFriend',
        methodLabel: '分享到微信',
        label: '微信',
        value: exports.SHARE_CHANNELS.WXFRIEND
    },
    {
        methodName: 'shareToWxTimeline',
        methodLabel: '分享到微信朋友圈',
        label: '微信朋友圈',
        value: exports.SHARE_CHANNELS.WXTIMELINE
    },
    {
        methodName: 'shareToCopy',
        methodLabel: '复制链接',
        label: '复制链接',
        value: exports.SHARE_CHANNELS.COPY
    }
];
exports.BEHAVIOR_EVENT = {
    CHANNEL_SHARE_SUCCESS: 'CHANNEL_SHARE_SUCCESS' // 渠道分享成功
};
//# sourceMappingURL=data:application/json;base64,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